import { Text } from 'components/library';

import { IGuide } from 'types/guide';

import Guide from './components/Guide';

import * as S from './styled';

interface GuidesListProps {
    guides: IGuide[];
    title?: string;
    dataLocator?: string;
    onDownload: (name: string) => void;
}

const GuidesList = ({ guides, title, dataLocator, onDownload }: GuidesListProps) => (
    <>
        {title && (
            <Text type="caption" color="text-secondary-subdued" bold mb={8}>
                {title}
            </Text>
        )}
        <S.GuidesList>
            {guides.map(({ name, preview, download_url: downloadUrl }: IGuide, index) => (
                <S.GuidesListItem key={name} data-locator={`${dataLocator}${index}`}>
                    <Guide title={name} img={preview} link={downloadUrl} onDownload={onDownload} />
                </S.GuidesListItem>
            ))}
        </S.GuidesList>
    </>
);

export default GuidesList;
